export const globalVariables = {
  countryId: 233
}
